import { Page, Spinner } from '@honestica/ui-kit/src';
import React from 'react';

type SuspenseProp = {
  children: React.ReactNode;
};

export const Suspense = (props: SuspenseProp) => (
  <React.Suspense
    fallback={
      <Page.Full>
        <Spinner />
      </Page.Full>
    }
  >
    {props.children}
  </React.Suspense>
);
